import React, { useEffect, useState } from "react";
import "./App.css";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip,
  LineChart, Line, CartesianGrid
} from "recharts";

function App() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const API = "https://incidentiq-ryxt.onrender.com";

  // ✅ LOAD EXISTING INCIDENTS (CRITICAL FIX)
  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await fetch(`${API}/incidents`);
        const data = await res.json();
        setHistory(data.reverse()); // latest first
      } catch (err) {
        console.log("Backend sleeping...");
      }
    };

    loadData();
  }, []);

  const triggerIncident = async () => {
    setLoading(true);

    try {
      const severities = ["low", "medium", "high"];
      const randomSeverity = severities[Math.floor(Math.random() * 3)];

      const res = await fetch(`${API}/event`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          source: "kubernetes",
          message: "Pod crash error detected",
          severity: randomSeverity
        })
      });

      if (!res.ok) {
        alert("Backend error");
        setLoading(false);
        return;
      }

      const data = await res.json();

      // ✅ SAFE UPDATE
      if (data && data.event) {
        setHistory((prev) => [data, ...prev]);
      }

    } catch (err) {
      alert("Backend waking up (Render cold start). Try again.");
    }

    setLoading(false);
  };

  // ✅ SAFE DATA (prevents crash)
  const severityData = [
    { name: "Low", value: history.filter(h => h?.event?.severity === "low").length },
    { name: "Medium", value: history.filter(h => h?.event?.severity === "medium").length },
    { name: "High", value: history.filter(h => h?.event?.severity === "high").length }
  ];

  // ✅ CLEAN TIMELINE (NO RANDOM)
  const timelineData = history.map((_, i) => ({
    index: i + 1,
    incidents: i + 1
  }));

  return (
    <div className="container">
      <h1>🚀 IncidentIQ Dashboard</h1>

      <button onClick={triggerIncident} disabled={loading}>
        {loading ? "Processing..." : "Trigger Incident"}
      </button>

      <h2>Total Incidents: {history.length}</h2>

      <div className="charts">
        <div className="card">
          <h3>📊 Severity Distribution</h3>
          <BarChart width={350} height={250} data={severityData}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#4CAF50" />
          </BarChart>
        </div>

        {/* 🔥 GRAFANA EMBED */}
        <div className="card">
            <h3>📡 Live Monitoring (Grafana)</h3>
            <iframe
            src="https://dandruff-amplify-tidings.ngrok-free.dev/d/adnjq94/f09f9a80-incidentiq-sre-dashboard?orgId=1&from=now-5m&to=now&timezone=browser&refresh=5s&kiosk"
            width="100%"
            height="450"
            frameBorder="0"
            title="Grafana Dashboard">
            </iframe>
        </div>

        <div className="card">
          <h3>📈 Incident Timeline</h3>
          <LineChart width={400} height={250} data={timelineData}>
            <XAxis dataKey="index" />
            <YAxis />
            <Tooltip />
            <CartesianGrid stroke="#ccc" />
            <Line type="monotone" dataKey="incidents" stroke="#2196F3" />
          </LineChart>
        </div>
      </div>

      <div className="ai-box">
        <h3>🤖 AI Analysis</h3>
        <p><b>Root Cause:</b> High load caused crash</p>
        <p><b>Fix:</b> Restart service & scale replicas</p>
        <p><b>Summary:</b> Generated by local AI</p>
      </div>

      <h2>📜 Incident History</h2>

      {history.length === 0 && (
        <p>No incidents yet. Click "Trigger Incident"</p>
      )}

      {history.map((item, index) => (
        <div key={index} className="history-card">
          <p><b>Service:</b> {item?.event?.source}</p>
          <p><b>Issue:</b> {item?.event?.message}</p>
          <p><b>Severity:</b> {item?.event?.severity}</p>
          <p><b>Root Cause:</b> {item?.analysis?.root_cause}</p>
          <p><b>Fix:</b> {item?.analysis?.fix}</p>
          <p><b>Action:</b> {item?.action}</p>
          <p><b>Alert:</b> {item?.alert}</p>
        </div>
      ))}
    </div>
  );
}

export default App;